import type { NPCConfig } from '@/entities';
import V2SharedNPCs from "@/config/NPCConfigs/v2/V2SharedNPCs";
// import {StoryManager} from "@/systems";

const config: NPCConfig[] = [
  {
    x: 1930,
    y: 1170,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'bar_3',
      nodes: {
        bar_3: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Selamat datang, ada yang bisa dibantu?',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_4"
        },
        bar_4: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Oh kamu Yan? Sudah lama tidak melihat kamu di desa',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_5"
        },
        bar_5: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Selamat datang kembali Yan, ada yang bisa dibantu?',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_6"
        },
        bar_6: {
          id: 'bar_1',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_2",
          choices: [
            {
              text: 'Kabar baru apa selamat aku di kota?',
              nextDialogId: 'bar_a1',
            },
            {
              text: 'Apa berita terbaru hari ini?',
              nextDialogId: 'bar_b1',
            },
            {
              text: 'Keluar',
              nextDialogId: 'end',
              isEnd : true
            },
          ],
        },
        bar_b1: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Hari ini adalah hari peringatan tentang kejadian 15 tahun lalu.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_b2"
        },
        bar_b2: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Rencananya akan dilakukan misa untuk mengenang arwah-arwah korban dari kejadian itu.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_b3"
        },
        bar_b3: {
          id: 'bar_1',
          speaker: '',
          text: '',
          choices: [
            {
              text: 'Apa yang terjadi 15 tahun lalu?',
              nextDialogId: 'bar_c1',
            },
            {
              text: 'Dimana misa akan diadakan?',
              nextDialogId: 'bar_d1',
            },
          ],
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_a2"
        },
        bar_d1: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Di gereja baru, diatas bukit.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          isEnd : true,
        },
        bar_c1: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Mungkin kamu lupa karena kamu masih kecil saat kejadian itu.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_c2"
        },
        bar_c2: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Beberapa gadis mati diwaktu yang dekat.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_c3"
        },
        bar_c3: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Semua orang menuduh kejadian ini kepada Songko.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_c4"
        },
        bar_c4: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: '',
          choices: [
            {
              text: 'Songko, apa itu?',
              nextDialogId: 'bar_f1',
            },
            {
              text: 'Berapa korban di kejadian itu?',
              nextDialogId: 'bar_g1',
            },
          ],
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
        },
        bar_f1: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Menurut Legenda, Songko adalah mahluk yang membunuh gadis perawan',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_f2"
        },
        bar_f2: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Songko menyerap energi dari korbannya untuk menjadi makin muda dan hidup kekal',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_f3"
        },
        bar_f3: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Dan dia bisa berubah wujud menjadi wanita biasa.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          isEnd : true
        },
        bar_g1: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Korban mencapai 3 orang.. semua ditemukan mati dalam waktu dekat.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_g2"
        },
        bar_g2: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Dan, jika diitung ibu mu.. menjadi 4 orang',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_g3"
        },
        bar_g3: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Walaupun ibu mu, kita tidak tahu apakah dia benar-benar mati dibunuh Songko atau dia meninggalkan desa',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_g4"
        },
        bar_g4: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Ada yang bilang ibu mu kabur ke kota dan tidak kembali karena takut dibunuh Songko...',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          isEnd : true,
        },
        bar_a1: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Selama kamu pergi, datang keluarga ibu Holga bersama dengan anaknya ke desa ini.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_a2"
        },
        bar_a2: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Sekitar 2 tahun lalu.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_a3"
        },
        bar_a3: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Dia sekarang tinggal di dekat rumahmu.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_a4"
        },
        bar_a4: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Selain itu datang Romo Darius diutus ke desa ini',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_a5"
        },
        bar_a5: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Beliau sangat di hormati oleh orang-orang di desa.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_a6"
        },
        bar_a6: {
          id: 'bar_1',
          speaker: 'Pegawai',
          text: 'Tetapi ada kemungkinan ini tahun terakhir Romo disini karena dia akan diutus ke tempat lain.',
          characterImage: '/assets/character/v2/shop_clerk.png',
          backgroundImage: '/assets/backdrop/warteg.png',
          nextDialogId : "bar_6"
        },
      },
    },
  },
  {
    x: 2480,
    y: 1860,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/gate_close.png',
    dialogTree: {
      startDialogId: 'toilet_1',
      nodes: {
        toilet_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Pintu ini sepertinya terkunci',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "toilet_2"
        },
        toilet_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Kira-kira mengarah kemana pintu ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          isEnd : true
        },
      },
    },
  },

  {
    x: 1500,
    y: 1300,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    interactOnce : true,
    scale : 0.5,
    hideOnState : ["BEAR_RETRIEVED"],
    spriteImage: 'assets/sprite/glitter_small.gif',
    dialogTree: {
      startDialogId: 'bear_1',
      nodes: {
        bear_1: {
          id: 'bear_1',
          speaker: 'Yan',
          text: 'Apa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "bear_2",
        },
        bear_2: {
          id: 'toilet_1',
          speaker: '',
          itemId : "teddy_bear",
          text: 'Yan mendapatkan boneka beruang!',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          storyAction: { type: 'addState', value: "BEAR_RETRIEVED" },
          itemReward: { itemId: 'teddy_bear', quantity: 1},
          nextDialogId : "bear_3",
        },
        bear_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Boneka milik siapa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "bear_4",
        },
        bear_4: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Jika tidak ada yang punya, bisa ku berikan ke Diana!',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          isEnd : true
        },
      },
    },
  },

  {
    x: 1000,
    y: 1230,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    scale : 1.5,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'exit_1',
      // triggerOnCollision: true,
      nodes: {
        exit_1: {
          id: 'bear_1',
          speaker: 'Yan',
          text: 'Ini adalah gerbang keluar dari desa',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/portal.png',
          nextDialogId : "exit_2",
        },
        exit_2: {
          id: 'bear_1',
          speaker: 'Yan',
          text: 'Belum saatnya aku kembali ke kota',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/portal.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1700,
    y: 1550,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'toilet_1',
      nodes: {
        toilet_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ini adalah toilet umum.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "toilet_2"
        },
        toilet_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Belum perlu ke toilet sekarang.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2400,
    y: 750,
    name: 'Romo Darius',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_darius.png', // Use NPC image
    repeatable : true,
    dialogTree: {
      startDialogId: 'romo_part2_1',
      nodes: {
        romo_part2_1: {
          id: 'romo_part2_1',
          speaker: 'Romo Darius',
          text: `Selamat pagi nak, apa yang kamu sedang cari.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId : "romo_part2_2",
        },
        romo_part2_2: {
          id: 'romo_part2_2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          choices: [
            {
              text: 'Aku ingin memberi sumbangan ke gereja. ',
              nextDialogId: 'romo_bible_1',
              requirements: {
                requiredItems: [{ itemId: 'coin_gold', quantity: 200 }],
              },
              consumeItems: [
                { itemId: 'coin_gold', quantity: 200 }
              ],
              itemReward: { itemId: 'bible', quantity: 1},
            },
            {
              text: 'Hadiah untuk adik saya',
              nextDialogId: 'romo_part2_3a',
            },
            {
              text: 'Mencari Pencerahan',
              nextDialogId: 'romo_part2_3b',
            },
          ],
        },
        romo_bible_1: {
          id: 'romo_bible_1',
          speaker: 'Romo Darius',
          text: `Terima kasih atas sumbangan kamu. Gereja sangat membutuhkan ini.`,
          storyActions : [
            { type: 'addState', value: "DONATED_TO_CHURCH" },
            { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
          ],
          characterImage: '/assets/character/v2/darius_h.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'romo_bible_2',
        },
        romo_bible_2: {
          id: 'romo_bible_1',
          speaker: 'Romo Darius',
          text: `Ijinkan saya memberikan ini atas bentuk terima kasih`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'romo_bible_3',
        },
        romo_bible_3: {
          id: 'romo_bible_1',
          speaker: 'Romo Darius',
          text: `Yan menerima sebuah alkitab!`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'romo_bible_4',
        },
        romo_bible_4: {
          id: 'romo_bible_4',
          speaker: 'Yan',
          text: `Alkitab.... mungkin ini bisa diberikan untuk Diana.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          isEnd : true
        },
        romo_part2_3a: {
          id: 'romo_part2_3a',
          speaker: 'Romo Darius',
          text: `Apapun itu yang kamu cari, tidak ada disini.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          isEnd : true
        },
        romo_part2_3b: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Ini tempat yang tepat. Ayo kita pejamkan mata dan berdoa.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'romo_part2_4',
        },
        romo_part2_4: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `.....`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/black.ktx2',
          fade : true,
          nextDialogId: 'romo_part2_5',
        },
        romo_part2_5: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `.....`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/black.ktx2',
          fade : true,
          nextDialogId: 'romo_part2_6',
        },
        romo_part2_6: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `.....`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/black.ktx2',
          fade : true,
          nextDialogId: 'romo_part2_7',
        },
        romo_part2_7: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Doa Selesai.`,
          fade : true,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'romo_part2_8',
        },
        romo_part2_8: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Doa Selesai.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          choices: [
            {
              text: 'Doa apa itu? tidak ada dialognya sama sekali?',
              nextDialogId: 'romo_part2_9',
            },
            {
              text: 'Terima kasih Romo.',
              nextDialogId: 'romo_end',
            },
          ],
        },
        romo_part2_9: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Terkadang jawaban dari pertanayan yang di cari ada di diri sendiri.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          isEnd : true,
        },
        romo_end: {
          id: 'romo_end',
          speaker: 'Romo Darius',
          text: `Sama-sama. Kembali lagi jika membutuhkan pencerahan.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          isEnd:true
        },
      },
    },
  },
  {
    x: 3050,
    y: 950,
    name: 'Ato',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_ato.png', // Use NPC image
    dialogTree: {
      startDialogId: 'ato_part1_1',
      nodes: {
        ato_part1_1: {
          id: 'ato_part1_1',
          speaker: 'Ato',
          text: `Aku sangat ingin mabuk! Sayangnya, uang ku kurang!`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2230,
    y: 1650,
    name: 'Sondakh',
    spriteImage: 'assets/sprite/sprite_sondakh.png', // Use NPC image
    dialogTree: {
      startDialogId: 'sondakh_1',
      nodes: {
        sondakh_1: {
          id: 'sondakh_1',
          speaker: 'Sondakh',
          text: `Sepertinya kita kedatangan orang kota semalam.`,
          characterImage: '/assets/character/v2/sondakh.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "sondakh_2",
        },
        sondakh_2: {
          id: 'sondakh_2',
          speaker: 'Sondakh',
          text: `Pagi-pagi saja sudah berisik, menggangu ketenangan warga saja.`,
          characterImage: '/assets/character/v2/sondakh.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "sondakh_3",
        },
        sondakh_3: {
          id: 'sondakh_3',
          speaker: 'Sondakh',
          text: `Mereka tidak mengerti bahwa aku perlu menjaga kencantikan dengan tidur yang cukup setiap hari.`,
          characterImage: '/assets/character/v2/sondakh.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2300,
    y: 1700,
    name: 'Holga',
    spriteImage: 'assets/sprite/sprite_holga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Sondakh',
          text: `Sondakh, anakku, adalah anak paling cantik di seluruh desa.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'holga_2',
          speaker: 'Sondakh',
          text: `Suatu hari dia akan menikah dengan orang kota yang kaya raya!`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2150,
    y: 1155,
    name: 'Anak Kecil',
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    repeatable : true,
    hideOnState : ["BONEKA_GIVEN"],
    dialogTree: {
      startDialogId: 'anak_1',
      nodes: {
        anak_1: {
          id: 'anak_1',
          speaker: 'Yan',
          text: `Anak kecil ini sepertinya sedang menangis`,
          characterImage: '/assets/character/v2/little_girl_a.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "anak_2",
        },
        anak_2: {
          id: 'anak_2',
          speaker: '',
          text : "",
          characterImage: '/assets/character/v2/little_girl_a.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          choices: [
            {
              text: 'Berikan boneka ke adik kecil',
              nextDialogId: 'anak_b1',
              requirements: {
                requiredItems: [{ itemId: 'teddy_bear', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'teddy_bear', quantity: 1 }
              ],
            },
            {
              text: 'Kenapa menangis dik?',
              nextDialogId: 'anak_3',
            },
            {
              text: 'Sedang mencari apa dik?',
              nextDialogId: 'anak_3',
            },
          ],
        },
        anak_b1: {
          id: 'anak_3',
          speaker: 'Anak Kecil',
          text: `Wah, terima kasih banyak kak!`,
          characterImage: '/assets/character/v2/little_girl_h.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "anak_4",
          storyActions : [
            { type: 'addState', value: "BONEKA_GIVEN" },
            { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
          ],
          isEnd : true
        },
        anak_3: {
          id: 'anak_3',
          speaker: 'Anak Kecil',
          text: `Aku sedang mencari boneka ku, entah hilang dimana`,
          characterImage: '/assets/character/v2/little_girl_a.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "anak_4",
        },
        anak_4: {
          id: 'anak_4',
          speaker: 'Anak Kecil',
          text: `Tolong aku kak!`,
          characterImage: '/assets/character/v2/little_girl_a.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          isEnd : true,
        },
      },
    },
  },

];

export default config;
